<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const EyeSlashIcon = getIcon("EyeSlashIcon");
</script>

{#if typeof EyeSlashIcon === 'string'}
	<img src={EyeSlashIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof EyeSlashIcon === 'function'}
	<svelte:component this={EyeSlashIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
